import { render, staticRenderFns } from "./ExclusivoTerrestre.vue?vue&type=template&id=571880a9&scoped=true"
import script from "./ExclusivoTerrestre.vue?vue&type=script&lang=js"
export * from "./ExclusivoTerrestre.vue?vue&type=script&lang=js"
import style0 from "./ExclusivoTerrestre.vue?vue&type=style&index=0&id=571880a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571880a9",
  null
  
)

export default component.exports